import { render, staticRenderFns } from "./SettingsLocationForm.vue?vue&type=template&id=0a12ec3c&scoped=true&"
import script from "./SettingsLocationForm.vue?vue&type=script&lang=ts&"
export * from "./SettingsLocationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a12ec3c",
  null
  
)

export default component.exports